import {
  FlexRow,
  LabeledInput,
  IconButton,
  IconContainer,
  Tooltip,
} from '@epam/promo';
import { useRef, useEffect, useState } from 'react';
import { Icon } from '@epam/uui';
import './index.scss';
import { ReactComponent as infoIcon } from '@epam/assets/icons/common/notification-info-outline-18.svg';

const LabeledInputWithCustomTooltip = ({
  icon,
  label,
  tooltip,
  className,
  isRequired,
  iconPosition = 'right',
}: {
  icon?: Icon;
  label?: string;
  tooltip?: string;
  className?: string;
  isRequired?: boolean;
  iconPosition?: 'left' | 'right';
}) => {
  const [iconOffset, setIconOffset] = useState<number>(0);
  const labelRef = useRef<HTMLElement>();

  useEffect(() => {
    if (iconPosition === 'right' && labelRef?.current) {
      const labelEl = labelRef.current.querySelector('.uui-label');
      const labelElWidth = (labelEl as HTMLElement)?.offsetWidth ?? 0;
      const labelPaddingLeftOffset = parseInt(
        getComputedStyle(labelRef.current).paddingLeft
      );
      setIconOffset(labelElWidth + labelPaddingLeftOffset);
    }
  }, [label, iconPosition]);

  const tooltipIcon = tooltip && (
    <Tooltip
      closeOnMouseLeave={'boundary'}
      renderContent={() => (
        <div
          className={'label-tooltip__text'}
          dangerouslySetInnerHTML={{ __html: tooltip }}
        />
      )}
    >
      <IconButton
        icon={icon ? icon : infoIcon}
        cx={'label-tooltip__icon'}
        rawProps={{ style: { left: `${iconOffset}px` } }}
      />
    </Tooltip>
  );

  const inlineTooltipIcon = tooltip && (
    <Tooltip
      closeOnMouseLeave={'boundary'}
      renderContent={() => (
        <div
          className={'label-tooltip__text'}
          dangerouslySetInnerHTML={{ __html: tooltip }}
        />
      )}
    >
      <IconContainer
        icon={icon ? icon : infoIcon}
        cx={'label-tooltip__icon--left'}
      />
    </Tooltip>
  );

  if (iconPosition === 'left') {
    return (
      <FlexRow cx={'label-container'}>
        <LabeledInput
          label={
            <FlexRow alignItems="center" spacing="6">
              {inlineTooltipIcon}
              <span>{label}</span>
            </FlexRow>
          }
          cx={className}
          isRequired={isRequired}
        />
      </FlexRow>
    );
  }

  return (
    <FlexRow cx={'label-container'}>
      <LabeledInput
        label={label}
        cx={className}
        ref={labelRef}
        isRequired={isRequired}
      />
      {tooltipIcon}
    </FlexRow>
  );
};

export default LabeledInputWithCustomTooltip;
